<template>
  <tbody class="item">
    <tr v-for="item in 5" :key="item">
      <td></td>
      <td v-for="itemCell in 6" :key="itemCell">
        <v-skeleton-loader class="text" type="text" />
      </td>
      <td>
        <v-skeleton-loader class="avatar" type="avatar" />
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
tr {
  padding: 0px 8px;
  position: relative;
  &:after {
    content: "";
    border-bottom: 1px solid var(--v-gray-lighten2);
    position: absolute;
    width: 100%;
    left: 0px;
    bottom: 0px;
  }
}
tr td {
  border-bottom: transparent;

  &:first-child {
    display: none;
  }
  &:nth-child(2) {
    .v-skeleton-loader {
      width: 175px;
    }
  }
}

.v-skeleton-loader {
  &.avatar::v-deep {
    display: flex;
    justify-content: flex-end;
    .v-skeleton-loader__avatar {
      width: 42px;
      height: 42px;
      border-radius: 100%;
    }
  }
}
</style>